import { Component, ElementRef, ViewChild } from '@angular/core';
import { PCESEmailLists } from '../models/PCES-email-lists.model';
import { NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { map, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { GridApi, IServerSideDatasource, IServerSideGetRowsParams,  ICellRendererParams, ColDef} from 'ag-grid-community';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PcesEmailDetailsComponent } from './pces-email-details/pces-email-details.component';
import { PCESModalComponent } from '../pces-client-lists/pces-lists-modal/pces-lists-modal.component';

@Component({
  selector: 'app-pces-email-lists',
  templateUrl: './pces-email-lists.component.html',
  styleUrls: ['./pces-email-lists.component.scss']
})

// PCES Client List Component
export class PcesEmailListsComponent {

  // Assign Client details component to be the detail cell rendered
  public detailCellRenderer: any = PcesEmailDetailsComponent;  

  rowData: PCESEmailLists[] = [];
  
  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;

  constructor(private http: HttpClient, private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private dialog: MatDialog, private zone: NgZone) { }

  search_email: FormGroup = this.fb.group({
    clientname: [''],
    email: [''],
  })
  
  private apiUrl = '/api/pces_lists/pces_email_lists.php';

  // variable to store universal filter 
  universalFilter = ''

  // default column definitions
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  };

  columnDefs: ColDef[] = [
    { field: 'email_uuid', headerName: 'UUID', hide: true},
    {
      headerName: 'Client Name',
      field: 'clientname',
      cellStyle: {'font-weight': 'bold'},         
      cellRenderer: 'agGroupCellRenderer',           // Add Drop Down Detail
      width: 500
    },            
    {
      headerName: 'Email Address',
      field: 'email',
      width: 500
    },    
    {
      headerName: 'Action', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteEmail(params);
          });
        });
        return button;
      }, editable: false, width: 100,
    },        
  ]


  //Apply filter dynmically
  ngAfterViewInit() {
    console.log('ngAfterViewInit:')
    if (this.agGrid) {
      this.route.queryParamMap.subscribe((params) => {
        const clientname = params.get('clientname');
        const email = params.get('email');
        
        if (clientname) {
          this.applyClientName(clientname);
          console.log('clientname:',clientname)
        }
        else if (email) {
          this.applyEmail(email);
          console.log('email:',email)
        }
        else {
          this.agGrid.api.setFilterModel({});
        }
      });
    }
  }


  //Apply filter for ClientName
  applyClientName(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        clientname: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  //Apply filter for Email
  applyEmail(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        email: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  search() {
    const clientname = this.search_email.get('clientname')?.value
    const email = this.search_email.get('email')?.value
    if (clientname) {
      this.router.navigate(['/pces_email_lists'], { queryParams: { clientname: clientname } });
    }
    else if (email) {
      this.router.navigate(['/pces_email_lists'], { queryParams: { email: email } });
    }
    else {
      console.log('Invalid search data.')
    }    
  }

  //Reset the filter by setting to empty object
  resetFilter() {
    this.router.navigate(['/pces_email_lists']);
    this.search_email.get('clientname')?.setValue('');
    this.search_email.get('email')?.setValue('');
  }  

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api
    params.api.setServerSideDatasource(this.getServerSideDatasource());
    this.gridApi = params.api; 
  }


  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getEmailList(params.request.startRow, params.request.endRow, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              if (response) {
                console.log(response);
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  getEmailList(startRow: number = 0, endRow: number = 0, filterModel: any = {}, sortModel: any = []) {
    const urlApi = this.apiUrl;

    const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
      console.log('Filter model:', filterModel);
      console.log('Filter', filter)

      let operator = '';
      let value = '';

      if (filter.filterType === 'text') {
        operator = filter.type;
        value = filter.filter;
      } else if (filter.filterType === 'set') {
        operator = 'equals'; // Or any other appropriate operator for set filter
        value = filter.values.join(','); // Join selected values with a delimiter if needed
      }

      return {
        column,
        operator,
        value,
      };
    });

    const params: any = {
      startRow: startRow,
      endRow: endRow,
      sortModel: JSON.stringify(sortModel),
      filters: JSON.stringify(filters),
    };

    console.log('an array of filter object: ', filters)
    const url = `${urlApi}?startRow=${startRow}&endRow=${endRow}&universalFilter=${this.universalFilter}`;

    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        return {
          rowData: response.data,
          rowCount: response.total,
        };
      }),
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
      filter(response => response !== null)
    );

  }  

  createPCESCEmail() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Create New Email',
        modalMessage: {},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }
  
  deleteEmail(params: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    const email_uuid = params.data.email_uuid;
    const clientname = params.data.clientname;

    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Email',
        modalMessage: {uuid: params.data.email_uuid, client_name: params.data.clientname},
      },
    };

    this.dialog.open(PCESModalComponent, dialogConfig);
  }


  uploadPaymentReport() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '555px'; // You can use pixels or other units
    dialogConfig.height = '375px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Upload Payment Report File',
        modalMessage: '',
      },
    };
    this.dialog.open(PCESModalComponent, dialogConfig);
  }

  pcesClientLists() {
    this.router.navigate(['/pces_client_lists']);
  }
  pcesEmailPendingLists() {
    this.router.navigate(['/pces_email_pending_lists']);
  }

}


